'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import React, { useState } from 'react';
import { useSearchParams } from 'next/navigation'

import styles from './ContentMetadata.module.scss';
import EmbedIcon from '@/public/svg/embed-lg.svg';
import EmbedModal from '@/components/EmbedModal/EmbedModal';
import { VideoClass } from '@/lib/types/api/video';
import { LOCAL_PLAYER_HOST } from '@/lib/constants';

interface EmbedModalButtonProps {
  className?: string;
  host: string;
  video: VideoClass;
}

const EmbedModalButton: React.FC<EmbedModalButtonProps> = ({ className, host, video }) => {
  const queryParameters = useSearchParams()
  const useLocalPlayer = queryParameters.get('localPlayer') ||
                         false

  const [isModalOpen, setIsModalOpen] = useState(false);

  const embedModalVideoProps = {
    image: video.image,
    ancestor_title: video.ancestor_title,
    title: video.title,
    show: {
      season: Number(video.show?.season),
      episode: Number(video.show?.episode),
    },
    legacy_tp_media_id: video.legacy_tp_media_id.toString(),
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  }

  const handleModalClosed = () => {
    setIsModalOpen(false)
  }

  let classNames = `${styles.content_metadata}`;

  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <li data-sentry-component="EmbedModalButton" data-sentry-source-file="EmbedModalButton.tsx">
      <button
        onClick={handleOpenModal}
        className={classNames}
        aria-label="Embed this video"
      >
        <EmbedIcon data-sentry-element="EmbedIcon" data-sentry-source-file="EmbedModalButton.tsx" />
      </button>

      <EmbedModal
        video={embedModalVideoProps}
        playerEmbedHost={useLocalPlayer ? LOCAL_PLAYER_HOST : host}
        isOpen={isModalOpen}
        onClose={handleModalClosed}
      data-sentry-element="EmbedModal" data-sentry-source-file="EmbedModalButton.tsx" />
    </li>
  );
};

export default EmbedModalButton;
